(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["compare-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const initializeCompareAccordion = (sectionEl) => {
      if (sectionEl.dataset.compareAccordionInitialized === 'true') return;

      const panels = Array.from(sectionEl.querySelectorAll('[data-compare-accordion-panel]'));
      const desktopMedia = window.matchMedia('(min-width: 1151px)');
      let activeIndex = 0;

      if (!panels.length) return;

      const setActive = (index) => {
        activeIndex = (index + panels.length) % panels.length;

        for (const [panelIndex, panel] of panels.entries()) {
          const isActive = panelIndex === activeIndex;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      };

      for (const [panelIndex, panel] of panels.entries()) {
        panel.addEventListener('click', () => setActive(panelIndex));
        panel.addEventListener('focus', () => setActive(panelIndex));
        panel.addEventListener('mouseenter', () => {
          if (desktopMedia.matches) setActive(panelIndex);
        });
      }

      sectionEl.dataset.compareAccordionInitialized = 'true';
      setActive(0);
    };

    for (const sectionEl of document.querySelectorAll('[data-compare-accordion]')) {
      initializeCompareAccordion(sectionEl);
    }

    document.addEventListener('shopify:section:load', (event) => {
      const sectionEl = event.target.matches('[data-compare-accordion]')
        ? event.target
        : event.target.querySelector('[data-compare-accordion]');
      if (sectionEl) initializeCompareAccordion(sectionEl);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["compare-find"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    for (const sectionEl of document.querySelectorAll('[data-compare-find]')) {
      for (const video of sectionEl.querySelectorAll('video')) {
        video.removeAttribute('autoplay');
        video.pause();
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["compare-paragraph"] && !Shopify.designMode) return;
  try {
    function getCompareParagraphs(scope = document) {
    if (scope.matches?.('[data-compare-paragraph]')) return [scope];
    return scope.querySelectorAll?.('[data-compare-paragraph]') || [];
  }

  function splitCompareParagraphText(textElement) {
    const characters = [];
    const textNodes = [];
    const walker = document.createTreeWalker(textElement, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) textNodes.push(walker.currentNode);

    const segmenter = typeof Intl.Segmenter === 'function'
      ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
      : null;

    for (const textNode of textNodes) {
      const fragment = document.createDocumentFragment();
      const segments = segmenter
        ? Array.from(segmenter.segment(textNode.textContent), ({ segment }) => segment)
        : Array.from(textNode.textContent);

      for (const characterText of segments) {
        if (/\s/.test(characterText)) {
          fragment.append(characterText);
          continue;
        }

        const character = document.createElement('span');
        character.className = 'compare-paragraph__character';
        character.textContent = characterText;
        fragment.append(character);
        characters.push(character);
      }

      textNode.replaceWith(fragment);
    }

    return characters;
  }

  async function initializeCompareParagraphs(scope = document) {
    for (const sectionEl of getCompareParagraphs(scope)) {
      if (sectionEl.dataset.compareParagraphInitialized === 'true') continue;

      const textElements = sectionEl.querySelectorAll('.compare-paragraph__desc');
      if (!textElements.length) continue;

      sectionEl.dataset.compareParagraphInitialized = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) continue;

      try {
        const { scroll, timeline } = await import(sectionEl.dataset.motionUrl);
        if (!sectionEl.isConnected) continue;

        const highlightColor = getComputedStyle(sectionEl)
          .getPropertyValue('--compare-paragraph-desc-highlight-color')
          .trim();
        const motionControls = [];

        for (const textElement of textElements) {
          const initialColor = getComputedStyle(textElement).color;
          const characters = splitCompareParagraphText(textElement);
          if (!characters.length) continue;

          const animation = timeline(
            characters.map((character, characterIndex) => [
              character,
              { color: [initialColor, highlightColor] },
              {
                at: characterIndex * 0.025,
                duration: 0.08,
                easing: 'linear'
              }
            ])
          );
          const stopScroll = scroll(animation, {
            target: textElement,
            offset: ['end end', 'start start']
          });

          motionControls.push({ animation, stopScroll });
        }

        sectionEl.compareParagraphMotionControls = motionControls;
      } catch (error) {
        delete sectionEl.dataset.compareParagraphInitialized;
        console.warn('Compare paragraph animation failed to initialize.', error);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initializeCompareParagraphs();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeCompareParagraphs(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    for (const sectionEl of getCompareParagraphs(event.target)) {
      for (const motionControl of sectionEl.compareParagraphMotionControls || []) {
        motionControl.stopScroll();
        motionControl.animation.stop();
      }

      delete sectionEl.dataset.compareParagraphInitialized;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["compare-series-tabs"] && !Shopify.designMode) return;
  try {
    function initializeCompareSeriesTabs(scope = document) {
    const components = scope.matches?.('[data-compare-series-tabs]')
      ? [scope]
      : scope.querySelectorAll('[data-compare-series-tabs]');

    for (const component of components) {
      if (component.dataset.compareSeriesTabsInitialized === 'true') continue;

      const tabsElement = component.querySelector('[data-index-series-tabs]');
      const panelsElement = component.querySelector('[data-index-series-panels]');
      const panels = Array.from(component.querySelectorAll('[data-index-series-tab]'));

      if (!tabsElement || !panels.length) continue;

      panelsElement?.classList.add('is-initialized');

      const setActive = (activeIndex) => {
        for (const [panelIndex, panel] of panels.entries()) {
          const isActive = panelIndex === activeIndex;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', String(!isActive));
        }

        const buttons = tabsElement.querySelectorAll('[data-index-series-tab-button]');
        for (const [buttonIndex, button] of buttons.entries()) {
          const isActive = buttonIndex === activeIndex;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', String(isActive));
          button.tabIndex = isActive ? 0 : -1;
        }
      };

      for (const [index, panel] of panels.entries()) {
        const button = document.createElement('button');
        const buttonId = `${component.id}-tab-${index}`;
        const panelId = `${component.id}-panel-${index}`;

        button.type = 'button';
        button.id = buttonId;
        button.className = 'index-series__tab-button';
        button.textContent = panel.dataset.tabTitle || `Tab ${index + 1}`;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panelId);
        button.setAttribute('data-index-series-tab-button', '');
        button.addEventListener('click', () => setActive(index));
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

          event.preventDefault();
          const nextIndex =
            event.key === 'ArrowRight'
              ? (index + 1) % panels.length
              : (index - 1 + panels.length) % panels.length;
          setActive(nextIndex);
          tabsElement.querySelectorAll('[data-index-series-tab-button]')[nextIndex].focus();
        });

        panel.id = panelId;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', buttonId);
        tabsElement.appendChild(button);
      }

      component.dataset.compareSeriesTabsInitialized = 'true';
      setActive(0);
    }
  }

  document.addEventListener('DOMContentLoaded', () => initializeCompareSeriesTabs());
  document.addEventListener('shopify:section:load', (event) => initializeCompareSeriesTabs(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["compare-slider"] && !Shopify.designMode) return;
  try {
    function syncCompareSliderA11y(swiper) {
    for (const [index, slide] of swiper.slides.entries()) {
      slide.setAttribute('aria-hidden', index === swiper.activeIndex ? 'false' : 'true');
    }
  }

  function syncCompareSliderMedia(swiper) {
    const sectionEl = swiper.el.closest('[data-compare-slider]');
    if (!sectionEl) return;

    const canPlay =
      sectionEl.compareSliderInView === true &&
      !document.hidden &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    for (const [index, slide] of swiper.slides.entries()) {
      const isActiveSlide = index === swiper.activeIndex;

      for (const video of slide.querySelectorAll('video')) {
        const shouldPlay = canPlay && isActiveSlide && video.offsetParent !== null;

        if (shouldPlay && video.paused) {
          video.play().catch(() => {});
        } else if (!shouldPlay && !video.paused) {
          video.pause();
        }
      }
    }
  }

  function syncCompareSliderState(swiper) {
    syncCompareSliderA11y(swiper);
    syncCompareSliderMedia(swiper);
  }

  function initializeCompareSliders(scope = document) {
    const sliders = scope.matches?.('[data-compare-slider]')
      ? [scope]
      : scope.querySelectorAll('[data-compare-slider]');

    for (const sectionEl of sliders) {
      if (sectionEl.dataset.compareSliderInitialized === 'true') continue;

      const swiperEl = sectionEl.querySelector('.compare-slider__swiper');
      const previousButton = sectionEl.querySelector('.swiper-button-prev');
      const nextButton = sectionEl.querySelector('.swiper-button-next');

      if (!swiperEl) continue;

      sectionEl.compareSliderInView = false;

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        effect: 'fade',
        observer: true,
        observeParents: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation: {
          prevEl: previousButton,
          nextEl: nextButton,
        },
        a11y: {
          enabled: true,
        },
        on: {
          init: syncCompareSliderState,
          resize: syncCompareSliderMedia,
          slideChange: syncCompareSliderState,
        },
      });

      const mediaObserver = new IntersectionObserver(
        ([entry]) => {
          sectionEl.compareSliderInView = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          syncCompareSliderMedia(swiper);
        },
        { threshold: 0.25 }
      );

      mediaObserver.observe(sectionEl);
      sectionEl.compareSliderMediaObserver = mediaObserver;
      sectionEl.compareSliderSwiper = swiper;
      sectionEl.dataset.compareSliderInitialized = 'true';
    }
  }

  document.addEventListener('DOMContentLoaded', () => initializeCompareSliders());
  document.addEventListener('shopify:section:load', (event) => initializeCompareSliders(event.target));
  document.addEventListener('visibilitychange', () => {
    for (const sectionEl of document.querySelectorAll('[data-compare-slider-initialized="true"]')) {
      if (sectionEl.compareSliderSwiper) syncCompareSliderMedia(sectionEl.compareSliderSwiper);
    }
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const sectionEl = event.target.matches?.('[data-compare-slider]')
      ? event.target
      : event.target.querySelector('[data-compare-slider]');

    sectionEl?.compareSliderMediaObserver?.disconnect();
    for (const video of sectionEl?.querySelectorAll('video') || []) {
      video.pause();
    }
    sectionEl?.compareSliderSwiper?.destroy(true, true);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["compare-spec"] && !Shopify.designMode) return;
  try {
    const syncCompareSpecifications = (scope = document) => {
    const components = scope.matches?.('[data-compare-spec]') ? [scope] : scope.querySelectorAll('[data-compare-spec]');

    for (const component of components) {
      const headerRow = component.querySelector('[data-compare-spec-header-row]');
      const firstFeatureRow = component.querySelector('[data-compare-spec-feature-row]');
      if (headerRow) {
        component.style.setProperty('--compare-spec-header-bg', headerRow.dataset.rowBackground);
        component.style.setProperty('--compare-spec-header-color', headerRow.dataset.rowColor);
        component.style.setProperty('--compare-spec-column-count', String(headerRow.children.length));
      }
      if (firstFeatureRow) {
        component.style.setProperty('--compare-spec-mobile-row-bg', firstFeatureRow.dataset.rowBackground);
        component.style.setProperty('--compare-spec-mobile-row-color', firstFeatureRow.dataset.rowColor);
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => syncCompareSpecifications());
  document.addEventListener('shopify:section:load', (event) => syncCompareSpecifications(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["compare-text-video"] && !Shopify.designMode) return;
  try {
    function getCompareTextVideoSections(scope = document) {
    if (scope.matches?.('[data-compare-text-video]')) return [scope];
    return scope.querySelectorAll?.('[data-compare-text-video]') || [];
  }

  function syncCompareTextVideoPlayback(sectionEl) {
    const canPlay =
      !document.hidden &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    for (const video of sectionEl.querySelectorAll('video')) {
      const shouldPlay =
        canPlay &&
        video.dataset.compareTextVideoInView === 'true' &&
        video.offsetParent !== null;

      if (shouldPlay && video.paused) {
        video.play().catch(() => {});
      } else if (!shouldPlay && !video.paused) {
        video.pause();
      }
    }
  }

  function initializeCompareTextVideos(scope = document) {
    for (const sectionEl of getCompareTextVideoSections(scope)) {
      if (sectionEl.dataset.compareTextVideoInitialized === 'true') continue;

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            entry.target.dataset.compareTextVideoInView =
              entry.isIntersecting && entry.intersectionRatio >= 0.25 ? 'true' : 'false';
          }

          syncCompareTextVideoPlayback(sectionEl);
        },
        { threshold: [0, 0.25] }
      );

      for (const video of sectionEl.querySelectorAll('video')) {
        video.removeAttribute('autoplay');
        video.pause();
        video.dataset.compareTextVideoInView = 'false';
        observer.observe(video);
      }

      sectionEl.compareTextVideoObserver = observer;
      sectionEl.dataset.compareTextVideoInitialized = 'true';
    }
  }

  document.addEventListener('DOMContentLoaded', () => initializeCompareTextVideos());
  document.addEventListener('shopify:section:load', (event) => initializeCompareTextVideos(event.target));
  document.addEventListener('visibilitychange', () => {
    for (const sectionEl of getCompareTextVideoSections()) {
      syncCompareTextVideoPlayback(sectionEl);
    }
  });
  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', () => {
    for (const sectionEl of getCompareTextVideoSections()) {
      syncCompareTextVideoPlayback(sectionEl);
    }
  });
  document.addEventListener('shopify:section:unload', (event) => {
    for (const sectionEl of getCompareTextVideoSections(event.target)) {
      sectionEl.compareTextVideoObserver?.disconnect();

      for (const video of sectionEl.querySelectorAll('video')) {
        video.pause();
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["compare-video-overlay"] && !Shopify.designMode) return;
  try {
    function getCompareVideoOverlaySections(scope = document) {
    if (scope.matches?.('[data-compare-video-overlay]')) return [scope];
    return scope.querySelectorAll?.('[data-compare-video-overlay]') || [];
  }

  function splitCompareVideoOverlayText(textElement) {
    const characters = [];
    const walker = document.createTreeWalker(textElement, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) textNodes.push(walker.currentNode);

    for (const textNode of textNodes) {
      const fragment = document.createDocumentFragment();

      for (const characterText of Array.from(textNode.textContent)) {
        if (/\s/.test(characterText)) {
          fragment.append(characterText);
          continue;
        }

        const character = document.createElement('span');
        character.className = 'compare-video-overlay__character';
        character.textContent = characterText;
        fragment.append(character);
        characters.push(character);
      }

      textNode.replaceWith(fragment);
    }

    return characters;
  }

  async function initializeCompareVideoOverlayText(scope = document) {
    const sections = getCompareVideoOverlaySections(scope);

    for (const sectionEl of sections) {
      if (sectionEl.dataset.compareVideoOverlayTextInitialized === 'true') continue;

      const textPanel = sectionEl.querySelector('.compare-video-overlay__text-panel');
      const textElements = textPanel?.querySelectorAll('.compare-video-overlay__text');

      if (!textPanel || !textElements?.length) continue;

      sectionEl.dataset.compareVideoOverlayTextInitialized = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) continue;

      try {
        const { scroll, timeline } = await import(sectionEl.dataset.motionUrl);

        if (!sectionEl.isConnected) continue;

        const motionControls = [];

        for (const textElement of textElements) {
          const characters = splitCompareVideoOverlayText(textElement);
          if (!characters.length) continue;

          const animation = timeline(
            characters.map((character, characterIndex) => [
              character,
              { opacity: [0, 1] },
              {
                at: characterIndex * 0.025,
                duration: 0.08,
                easing: 'linear'
              }
            ])
          );
          const stopScroll = scroll(animation, {
            target: sectionEl,
            offset: ['33.333% start', '66.667% start']
          });

          motionControls.push({ animation, stopScroll });
        }

        sectionEl.compareVideoOverlayTextAnimations = motionControls;
      } catch (error) {
        console.warn('Compare video overlay text animation failed to initialize.', error);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initializeCompareVideoOverlayText();

    if (customElements.get('compare-video-overlay-player')) return;

    class CompareVideoOverlayPlayer extends HTMLElement {
      #observer = null;
      #video = null;

      connectedCallback() {
        this.#video = this.querySelector('video');
        if (!this.#video) return;

        this.#video.removeAttribute('autoplay');
        this.#video.pause();

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.#observer = new IntersectionObserver((entries) => {
          const entry = entries[0];

          if (entry.isIntersecting && entry.intersectionRatio > 0) {
            this.#video.play().catch(() => {});
            return;
          }

          this.#video.pause();
        });

        this.#observer.observe(this);
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
        this.#video?.pause();
      }
    }

    customElements.define('compare-video-overlay-player', CompareVideoOverlayPlayer);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeCompareVideoOverlayText(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    for (const sectionEl of getCompareVideoOverlaySections(event.target)) {
      for (const motionControl of sectionEl.compareVideoOverlayTextAnimations || []) {
        motionControl.stopScroll();
        motionControl.animation.stop();
      }

      delete sectionEl.dataset.compareVideoOverlayTextInitialized;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["compare-video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    for (const sectionEl of document.querySelectorAll('[data-compare-video]')) {
      for (const video of sectionEl.querySelectorAll('video')) {
        video.removeAttribute('autoplay');
        video.pause();
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
